import parser from 'html-react-parser';
import React, { useEffect, useState } from 'react';

const BambooHRCareers = () => {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);
  const domain = 'worldsavvy.bamboohr.com';
  const version = '1.0.0';
  const departmentId = '';

  useEffect(() => {
    const embedUrl = `https://${domain}/jobs/embed2.php?version=${encodeURIComponent(
      version
    )}${
      departmentId ? `&departmentId=${encodeURIComponent(departmentId)}` : ''
    }`;

    fetch(embedUrl)
      .then(response => response.text())
      .then(setContent)
      .catch(error => {
        console.error('BambooHR-ATS: Failed to load careers', error);
        setError('Failed to load careers');
      });
  }, [domain, version, departmentId]);

  if (error) return <div>{error}</div>;

  if (!content) return <div style={{ textAlign: 'center' }}>Loading...</div>;

  return (
    <div>
      <div id='BambooHR-ATS'>{content && parser(content)}</div>
    </div>
  );
};

export default BambooHRCareers;
